module.exports = __webpack_public_path__ + "assets/cba56888064dae0a0da579cd68185931.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/FeatureTriggerShort.mp3
 ** module id = 490
 ** module chunks = 0
 **/